import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './NewProductionUploadFile.css';

const NEW_PRODUCTION_ROOT =
  process.env.REACT_APP_NEW_PRODUCTION_START_PATH || '/new-production';

function NewProductionUploadFile({
  currentPath,
  userId,
  onFileUploaded,
}) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={NEW_PRODUCTION_ROOT}
      sessionPrefix="new_production_file"
    />
  );
}

NewProductionUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default NewProductionUploadFile;
